//import $ from 'jquery';
import 'slick-carousel';
import simpleParallax from 'simple-parallax-js'
import Headroom from 'headroom.js'
import 'readmore-js'
import '@fancyapps/fancybox'
import '/src/js/filters.js'
import '/src/js/milestones.js'
import '/src/js/people.js'
import '/src/js/fullwidthslider.js'
import '/src/js/map.js'
import '/src/js/panorama.js'
import '/src/js/cookies.js'
import '/src/js/newsletter.js'
import '/src/js/contactform.js'

/* ==========================================================================
   Fade in elements with intersection observer
   ========================================================================== */

if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting === true) {
                entry.target.classList.add("fade-in--is-visible");
            } else {
                //entry.target.classList.remove("fade-in--is-visible");
            }
        });
    });
    var items = document.querySelectorAll(".fade-in");
    items.forEach(function (item, index) {
        observer.observe(item, index);
    });
} else {
    document.querySelector("body").classList.add("no-intersection-observer");
}

/* ==========================================================================
   Mobile Menu Button
   ========================================================================== */

const navButton = document.querySelector(".js-trigger-mobile-nav");
const navElement = document.querySelector(".main-nav");

navButton.addEventListener("click", function () {
    navElement.classList.toggle("is-active");
    this.classList.toggle("is-active");
    $('header').toggleClass('is-hover');
});


// Adds and Removes scroll class to transition header to black background and hides gradient
if (document.querySelector('.page--home') !== null) {
    if ('IntersectionObserver' in window) {
        var headerEl = document.querySelector(".header");
        var triggerEl = document.querySelector(".feature-banner");

        var handler = function handler(entries) {
            if (!entries[0].isIntersecting) {
                headerEl.classList.add("scroll");
            } else {
                headerEl.classList.remove("scroll");
            }
        };

        var observer = new window.IntersectionObserver(handler);
        observer.observe(triggerEl);
    }
}



/* ==========================================================================
   Toggle Sub Nav Dropdown for Mobile
   ========================================================================== */

// On mobile adds Open class if tapped to trigger dropdown
if ($(window).width() < 1024) {
    $('.with-sub-nav').click(function () {
        $('.sub-nav', this).toggleClass('open');
        $(this).next('.main-nav__link',).toggleClass('expand');
    });
}
else {

}

// Adds class to make header have black background on hover of items with subnavs
$('.with-sub-nav').hover(function () {
    $('header').addClass('is-hover');
},
    function () {
        $('header').removeClass('is-hover');
    });

// Toggles Search
$('.search-item').click(function () {
    $('.search-panel').toggleClass('open');
    $('header').toggleClass('is-hover');
});

// Hides Alert
$('.alert .close').click(function () {
    $('.alert').addClass('hide');
});

// Map Toggle 
$("input[name=switchLayout]:radio").click(function (ev) {
    if (ev.currentTarget.value == "Grid") {
        $('.map-listings').removeClass('with__map');
        $('.map-listings').addClass('with__grid');
        $(".map-listings__header .js-heading-body-text").hide();
    } else if (ev.currentTarget.value == "Map") {
        $('.map-listings').addClass('with__map');
        $('.map-listings').removeClass('with__grid');
        $('.map-listings').trigger('loadMap');
        $(".map-listings__header .js-heading-body-text").show();
    }
});

// Custom Select
$(".custom-select").each(function () {
    var classes = $(this).attr("class"),
        id = $(this).attr("id"),
        name = $(this).attr("name");
    var template = '<div class="' + classes + '">';
    template += '<button type="button" class="custom-select-trigger"><strong>' + $(this).attr("name") + ':</strong> ' + $(this).attr("placeholder") + '</button>';
    template += '<div class="custom-options">';
    $(this).find("option").each(function () {
        template += '<button type="button" class="custom-option ' + $(this).attr("class") + '" data-value="' + $(this).attr("value") + '">' + $(this).html() + '</button>';
    });
    template += '</div></div>';

    $(this).wrap('<div class="custom-select-wrapper column-4of12"></div>');
    $(this).hide();
    $(this).after(template);
});

$(".custom-select .custom-option:first-of-type").hover(function () {
    $(this).parents(".custom-options").addClass("option-hover");
}, function () {
    $(this).parents(".custom-options").removeClass("option-hover");
});

$(".custom-select .custom-select-trigger").on("click", function (e) {
    e.preventDefault();
    $('html').one('click', function () {
        $(".custom-select").removeClass("opened");
    });
    $(".custom-select-trigger").not(this).parents(".custom-select").removeClass("opened");
    $(this).parents(".custom-select").toggleClass("opened");
    event.stopPropagation();
});

$(".custom-select .custom-option").on("click", function (e) {
    e.preventDefault();
    $(this).parents(".custom-select-wrapper").find("select").val($(this).data("value"));
    $(this).parents(".custom-select-wrapper").find("select")[0].dispatchEvent(new Event("change"));
    $(this).parents(".custom-options").find(".custom-option").removeClass("selection");
    $(this).addClass("selection");
    $(this).parents(".custom-select").removeClass("opened");
    $(this).parents(".custom-select").find(".custom-select-trigger").text($(this).text());
});

// Custom Dropdown with links
$(".custom-select-links .custom-select-trigger").on("click", function (e) {
    e.preventDefault();
    $(this).parent().toggleClass("opened");
});

// Listings Entry Slider + Progress Bar
$(".listings-slider__slider").each(function () {
    var $slider = $(this);
    var $progressBar = $slider.parent().find('.listings-slider__slider-progress');
    var $progressBarLabel = $slider.parent().find('.listings-slider__slider-progress-label');
    $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var calc = ((nextSlide) / (slick.slideCount - 1)) * 100;
        $progressBar
            .css('background-size', calc + '% 100%')
            .attr('aria-valuenow', calc);
        $progressBarLabel.text(calc + '% completed');
    });

    $slider.slick({
        fade: false,
        dots: false,
        arrows: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: $slider.parent().find('.button--prev'),
        nextArrow: $slider.parent().find('.button--next'),
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1.3,
                slidesToScroll: 1,
                infinite: false
            }
        }
        ]
    });
});

// Testimonials Slider + Progress Bar + Randomise

$.fn.randomize = function (selector) {
    var $elems = selector ? $(this).find(selector) : $(this).children(),
        $parents = $elems.parent();

    $parents.each(function () {
        $(this).children(selector).sort(function (childA, childB) {
            // * Prevent last slide from being reordered
            if($(childB).index() !== $(this).children(selector).length - 1) {
                return Math.round(Math.random()) - 0.5;
            }
        }.bind(this)).detach().appendTo(this);
    });

    return this;
};

$(".testimonials-slider__slider").each(function() {
    var $testimonialsSlider = $(this);
    var $testimonialsprogressBar = $testimonialsSlider.parent().find('.testimonials-slider__slider-progress');
    var $testimonialsprogressBarLabel = $testimonialsSlider.parent().find('.testimonials-slider__slider-progress-label');

    $testimonialsSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        var calc = ((nextSlide) / (slick.slideCount - 1)) * 100;

        $testimonialsprogressBar
            .css('background-size', calc + '% 100%')
            .attr('aria-valuenow', calc);

        $testimonialsprogressBarLabel.text(calc + '% completed');
    });

    $testimonialsSlider.randomize().slick({
        fade: false,
        dots: false,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        prevArrow: $testimonialsSlider.parent().find('.button--prev'),
        nextArrow: $testimonialsSlider.parent().find('.button--next')
    });
});


// Timeline Slider + Progress Bar

$(".timeline__slider").each(function () {
    var timelineSlider = $(this);
    var timelineProgressBar = timelineSlider.closest(".timeline").find(".timeline__slider-progress");
    var timelineProgressBarLabel = timelineSlider.closest(".timeline").find(".timeline__slider-progress-label");

    timelineSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var calc = ((nextSlide) / (slick.slideCount - 1)) * 100;

        timelineProgressBar
            .css('background-size', calc + '% 100%')
            .attr('aria-valuenow', calc);

        timelineProgressBarLabel.text(calc + '% completed');
    });

    timelineSlider.slick({
        fade: true,
        dots: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: timelineSlider.closest(".timeline").find('.timeline--prev'),
        nextArrow: timelineSlider.closest(".timeline").find('.timeline--next'),
        appendDots: timelineSlider.closest(".timeline").find('.timeline__dots'),
        customPaging: function (slider, i) {
            var thumb = $(slider.$slides[i]).data();
            return ' ';
        }
    });
});


// Media Auto Slider for standard image galleries
$('.media-auto-slider').slick({
    fade: true,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: false,
    speed: 700,
    cssEase: 'linear'
});

// Read More / Less Toggle
$(document).on('click', '.icon__read-more', function () {
    var moreLessButton = $(".heading-copy__hidden").hasClass('open') ? 'Read More' : 'Read Less';
    $(this).text(moreLessButton);
    $(this).toggleClass('open');
    $(this).parent('div').find(".heading-copy__hidden").toggleClass('open');
});

$('[data-fancybox]').fancybox({
    hideScrollbar: false
});

// Accordion 
$(document).ready(function ($) {
    $('.accordion').find('.accordion__toggle').click(function () {

        let isActive = $(this).hasClass("active");

        $('.accordion__toggle').removeClass('active')

        if (!isActive) {
            $(this).toggleClass('active');
        }

        $(this).next().slideToggle('fast', function() {
            $(this).find(".full-width-slider__slider").slick("refresh");
        });

        if ($(this).parent(".accordion__item").attr("id")) {
            history.replaceState(null, null, "#" + $(this).parent(".accordion__item").attr("id"));
        }
    });

    let scrollToComponentHash = $(location).prop('hash');
    if (scrollToComponentHash?.length > 0 && $(scrollToComponentHash).length > 0) {
        let accordionToggle = $(scrollToComponentHash).find(".accordion__toggle").not(".active");
        if (accordionToggle.length) {
            // close other active panels
            $(scrollToComponentHash).closest(".accordion").find(".accordion__content").hide();
            $(scrollToComponentHash).closest(".accordion").find(".accordion__toggle.active").removeClass("active");
            // trigger click to open panel
            accordionToggle.trigger("click");
        }
        $("html").animate({
            scrollTop: $(scrollToComponentHash).offset().top - document.querySelector("header").offsetHeight
        }, 500);
    }
});

// Changes images on the side for desktop
$(".with__images .accordion__toggle").click(function () {
    var target = $(this).attr('id');
    var id = target.match(/\d+/);
    $('.accordion-images .image').addClass('hidden');
    $('#img_' + id).removeClass('hidden');
});

// Animated Body Background Color on Scroll through sections
if ('IntersectionObserver' in window) {
    var backgroundObserverOptions;
    if (window.matchMedia("(min-height: 1400px)").matches) {
        //console.log("min-height: 1400px, threshold: 0.75");
        backgroundObserverOptions = {
            root: null,
            rootMargin: '0px 0px',
            threshold: 0.75,
        };
    } else if (window.matchMedia("(min-height: 800px)").matches) {
        //console.log("min-height: 800px, threshold: 0.30");
        backgroundObserverOptions = {
            root: null,
            rootMargin: '0px 0px',
            threshold: 0.30,
        };
    } else {
        //console.log("else, threshold: 0.15");
        backgroundObserverOptions = {
            root: null,
            rootMargin: '0px 0px',
            threshold: 0.15,
        };
    }
    var backgroundObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                //console.log('entered: ' + entry.target.dataset["color"]);
                $('body').removeClass(function (index, css) {
                    return (css.match(/(^|\s)background-color__\S+/g) || []).join(' ');
                });
                $('body').addClass('background-color__' + entry.target.dataset["color"]);
            } else {
                //console.log('left: ' + entry.target.dataset["color"]);
            }
        });
    }, backgroundObserverOptions);
    var items = document.querySelectorAll(".page--home .animate-background");
    items.forEach(function (item, index) {
        backgroundObserver.observe(item, index);
    });
}

// Parallax Scrolling Images
var image = document.getElementsByClassName('parallax');
new simpleParallax(image, {
    delay: .6,
    transition: 'cubic-bezier(0,0,0,1)'
});

// Hiding Header on scroll
var myElement = document.querySelector("header");
// construct an instance of Headroom, passing the element
var headroom = new Headroom(myElement);
// initialise
headroom.init();

// Readmore 
$(".read-more__inner").readmore({
    speed: 75,
    collapsedHeight: 400,
    moreLink: "<button class='button button--secondary icon__arrow  icon__read-more icon__arrow'>Read More</button>",
    lessLink: "<button class='button button--secondary icon__arrow  icon__read-more icon__arrow open'>Read Less</button>",
    beforeToggle: function (trigger, element, expanded) {
        if (expanded) {
            element.attr("aria-expanded", "false");
            element.removeClass("read-more__inner--opened");
        } else {
            element.attr("aria-expanded", "true");
            element.addClass("read-more__inner--opened");
        }
    }
});

// Shielded Site
(function () {
    window.onload = function () {
        var frameName = new ds07o6pcmkorn({
            openElementId: "#shielded-logo",
            modalID: "modal",
        });
        frameName.init();
    }
})();

// Tranformations Featured First
$(document).on("click", ".featured-first-button", function (e) {
    e.preventDefault();
    $(this).html($(this).html() == "Newest" ? "Oldest" : "Newest");
    var accordion = $("#" + $(this).attr("data-accordion"));
    accordion.append(accordion.children('.accordion__item').get().reverse());
});

// Wrap tables output from the CMS
$(".umb-block-list table").each(function(){
    $(this).wrap("<div class='table-wrap'></div>");
});

// Comparison Slider
initComparisonSliderToggler();

$(".comparison-slider__toggle").on("input", function () {
    let slideValue = this.value;
    $(this).parents(".comparison-slider").find(".comparison-slider__after-image").css({ "clip-path": "polygon(0 0," + slideValue + "% 0," + slideValue + "% 100%, 0 100%)" });
    $(this).parents(".comparison-slider").find(".comparison-slider__label").fadeOut(250);
})

$(document).on("click", ".js-headline", function (e) {
    if ($(this).attr("id")) {
        history.replaceState(null, null, `#${$(this).attr("id")}`);
    }
});

function initComparisonSliderToggler() {
    $(".comparison-slider__toggle").each(function () {
        let slideWidth = $(this).parents(".comparison-slider").outerWidth() + 50;
        $(this).css({ "width": slideWidth + "px" });
        $(this).val(50)
    });
}
